import React, { useEffect, useRef, useState } from 'react';

const PINK = '#A9315B';
const MEDIA: Record<string, { src: string; poster?: string; label: string }> = {
  'tour-01-brand.mp4': { src: 'https://admojicanvas.b-cdn.net/onboarding/tour-01-brand-20260908.mp4', poster: '/tour/brand-scan-poster.jpg', label: 'Analyze your brand animation' },
  // Versioned durable asset verified by the release upload pipeline.
  'tour-welcome.mp4': { src: 'https://admojicanvas.b-cdn.net/onboarding/tour-welcome-v3-20260908.mp4', poster: '/tour/welcome-v3-poster.jpg', label: 'Welcome to AdMoji animation' },
};

function TourVideo({ media, wide }: { media: (typeof MEDIA)[string]; wide?: boolean }) {
  const video = useRef<HTMLVideoElement>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sync = () => {
      if (preference.matches) video.current?.pause();
      else void video.current?.play().catch(() => { /* Leave the poster visible if autoplay is unavailable. */ });
    };
    sync();
    preference.addEventListener('change', sync);
    return () => preference.removeEventListener('change', sync);
  }, []);

  return (
    <div data-testid="tour-video-slot" style={{ aspectRatio: wide ? '16 / 9' : '4 / 3', borderRadius: 8, overflow: 'hidden', background: '#EBEBEB', marginBottom: 12 }} onKeyDown={(event) => event.stopPropagation()}>
      {failed ? (
        <div role="status" style={{ display: 'grid', placeContent: 'center', height: '100%', padding: 16, textAlign: 'center', fontSize: 13, color: '#3D3A36' }}>
          Video unavailable. You can still follow the tour below.
        </div>
      ) : (
        <video ref={video} data-testid="tour-video" aria-label={media.label} src={media.src} poster={media.poster} muted loop playsInline disablePictureInPicture disableRemotePlayback tabIndex={-1} preload="metadata" onError={() => setFailed(true)} style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain', pointerEvents: 'none' }} />
      )}
    </div>
  );
}

export function TourVideoSlot({ file, wide }: { file?: string; wide?: boolean }) {
  if (!file) return null;
  const media = MEDIA[file];
  if (media) return <TourVideo key={file} media={media} wide={wide} />;
  return (
    <div data-testid="tour-video-slot" style={{ aspectRatio: wide ? '16 / 9' : '4 / 3', borderRadius: 8, border: `1.5px dashed ${PINK}`, background: 'rgba(169,49,91,0.08)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 3, padding: 8, marginBottom: 12 }}>
      <span style={{ fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 10, letterSpacing: '0.06em', textTransform: 'uppercase', color: PINK }}>Video</span>
      <span style={{ fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 11.5, color: '#161616' }}>{file}</span>
    </div>
  );
}
